import React, { createContext, useCallback, useContext } from "react";
import ym, { YMInitializer } from "react-yandex-metrika";
import { useContextPerson } from "hooks/persons";

const MetricsContext = createContext(undefined);

function YMInit({ account }) {
    if (!account) {
        return null;
    }

    const ymOptions = {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
    };

    return <YMInitializer accounts={[account]} options={ymOptions} version="2" />;
}

function MetricsProvider({ children }) {
    const { yandexMetrikaCounterId, person } = useContextPerson();
    const ymAccount = yandexMetrikaCounterId && parseInt(yandexMetrikaCounterId);

    const personId = person && person.id,
        regionId = person && person.regionId;

    const openPageEvent = useCallback(() => {
        if (!personId) return;
        ym("reachGoal", "open_page", { [personId]: { [regionId]: {} } });
    }, [personId, regionId]);

    return (
        <MetricsContext.Provider value={{ openPageEvent }}>
            <YMInit account={ymAccount} />
            {children}
        </MetricsContext.Provider>
    );
}

function useMetrics() {
    const context = useContext(MetricsContext);
    if (context === undefined) {
        throw new Error("useMetrics must be used within a MetricsProvider");
    }
    return context;
}

export { MetricsProvider, useMetrics };
